import ReplySection from './ReplySection';
import { ReplySectionProps, ReplySectionValueProps } from './types';

export type { ReplySectionProps, ReplySectionValueProps };
export default ReplySection;
